module.exports = __webpack_public_path__ + "img/ManHoleUpWithFlow.68889f24.svg";